import { useEffect, useState } from "react";
import { Icon, Modal } from "semantic-ui-react";
import { checkIfWmx } from "../../libs/common_utils";
import Registry from "../../libs/register_storage";
import { walmartMXTranslations } from "../../translations/walmartMXTranslations";

const HEADER_TEXT = "SYSTEM OUTAGE NOTIFICATION";
const CONTENT_TEXT_1 =
  "We're currently experiencing a system-wide issue affecting platform functionality. Our engineering team is actively investigating.";
const CONTENT_TEXT_2 =
  "You may encounter errors or degraded performance across the platform. We recommend holding off on critical work until service is restored.";
const CONTENT_TEXT_3 = "We'll update this notice as soon as we know more. Thank you for your patience.";

const DISMISSED_AT_KEY = "outageNotificationDismissedAt";
const DISMISS_DURATION_MS = 30 * 60 * 1000;

const OutageNotificationModal = () => {
  const isWmx = checkIfWmx();
  const headerText = isWmx ? walmartMXTranslations.outageNotificationHeader : HEADER_TEXT;
  const contentText1 = isWmx ? walmartMXTranslations.outageNotificationBody1 : CONTENT_TEXT_1;
  const contentText2 = isWmx ? walmartMXTranslations.outageNotificationBody2 : CONTENT_TEXT_2;
  const contentText3 = isWmx ? walmartMXTranslations.outageNotificationBody3 : CONTENT_TEXT_3;
  const [storage] = useState(() => new Registry(window.localStorage));
  const [isOpen, setIsOpen] = useState(() => {
    const dismissedAt = storage.getItem(DISMISSED_AT_KEY);
    return !(dismissedAt && Date.now() - dismissedAt < DISMISS_DURATION_MS);
  });
  const [mountNode] = useState(() => {
    const node = document.createElement("div");
    node.style.position = "relative";
    node.style.zIndex = "2147483647";
    return node;
  });

  useEffect(() => {
    document.body.appendChild(mountNode);
    return () => document.body.removeChild(mountNode);
  }, [mountNode]);

  const handleClose = () => {
    storage.setItem(DISMISSED_AT_KEY, Date.now());
    setIsOpen(false);
  };

  return (
    <Modal
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
      closeOnEscape={false}
      dimmer="blurring"
      mountNode={mountNode}
      open={isOpen}
      size="small"
    >
      <Modal.Header style={{ alignItems: "flex-start", display: "flex", justifyContent: "space-between" }}>
        <span>{headerText}</span>
        <Icon
          aria-label="Close modal"
          className="control"
          name="close"
          onClick={handleClose}
          style={{ cursor: "pointer", marginRight: 0 }}
        />
      </Modal.Header>
      <Modal.Content>
        <p>{contentText1}</p>
        <p>{contentText2}</p>
        <p>{contentText3}</p>
      </Modal.Content>
    </Modal>
  );
};

export default OutageNotificationModal;
